// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__GOGyt","title":"styles_title__3KUps","amount":"styles_amount__660K0"};